import Cookies from "js-cookie";

export const getCookie = (key) => {
  // return JSON.parse(Cookies.get(key));
  const cookie = Cookies.get(key);
  return cookie ? JSON.parse(cookie) : null;
};

export const setCookie = (key, value, options = {}) => {
  Cookies.set(key, JSON.stringify(value), options);
};

export const removeCookie = (key) => {
  Cookies.remove(key);
};

export const setAuthCookies = (key, value) => {
  Cookies.set(key, JSON.stringify(value), {
    expires: 120 / 1440,
    secure: true,
    sameSite: "Strict",
  });
};
